import { BackButton } from "components/Common/BackButton"
import { FlexBox } from "components/Common/FlexBox"
import { PageTitle } from "components/Common/PageTitle"
import ChevronLeft from "components/Icons/ChevronLeft"
import ChevronLeftBold from "components/Icons/ChevronLefBold"
import { Fragment } from "react"

const Header = ({
  onBack,
  title = "",
  disabled,
  theme = "light",
  rightAction,
  noLeftAction = false,
  isAppPaddingStyle,
}: {
  onBack?: () => void
  title?: string
  disabled?: boolean
  theme?: "dark" | "light"
  rightAction?: React.ReactNode
  noLeftAction?: boolean
  isAppPaddingStyle?: boolean
}) => {
  return (
    <FlexBox
      style={{
        height: 44,
        color: theme === "light" ? "inherit" : "#fff",
        padding: `0 ${isAppPaddingStyle ? 24 : 16}px`,
      }}
      $justify="space-between"
      $alignItems="center"
    >
      {noLeftAction ? (
        <div style={{ flexShrink: 0, width: 24, height: 24 }}></div>
      ) : (
        <BackButton
          onClick={() => {
            if (!disabled && onBack) {
              onBack()
            }
          }}
          style={{
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
            marginLeft: -4,
          }}
        >
          {theme === "light" ? (
            <ChevronLeft />
          ) : (
            <ChevronLeftBold fill={"#2CCCD3"} />
          )}
        </BackButton>
      )}

      <PageTitle>{title}</PageTitle>

      {
        <Fragment>
          {rightAction ?? (
            <div
              style={{ flexShrink: 0, width: 24, height: 44, marginRight: -4 }}
            ></div>
          )}
        </Fragment>
      }
    </FlexBox>
  )
}

export default Header
